import { createUserWithEmailAndPassword } from 'firebase/auth'
import React, { useState } from 'react'
import { auth } from '../firebase'
import { useNavigate } from 'react-router-dom'
import { Link } from 'react-router-dom'
// import {useNavigate} from 'react-router-dom'

const Signupfile = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const navigation = useNavigate()
  const submitDatatoFirebase = async (e) => {
    e.preventDefault();
    try {
      const credential = await createUserWithEmailAndPassword(auth, email, password);
      let userdetailid = credential.user
      localStorage.setItem("id", userdetailid.accessToken)
      localStorage.setItem("user", JSON.stringify(userdetailid))
      navigation('/login')
      // alert('check')
    }
    catch (error) {
      console.log(error);
    }
  }
  return (
    <div id="signupbg">
      <div className='signupdiv'>
        <h1>Welcome to Plantify</h1>
        <h2>Create your Account</h2>
        <form method='post'>
          <input type='email' placeholder='Enter Email' onChange={(event) => setEmail(event.target.value)}></input><br></br>
          <input type='password' placeholder='Enter Password' onChange={(event) => setPassword(event.target.value)}></input><br></br>
          <button type='submit' onClick={submitDatatoFirebase}>Signup</button>
        </form>
        <p>Already have an account ? </p><Link to="login">login</Link>
      </div>
    </div>
  )
}

export default Signupfile
